import { createSlice } from "@reduxjs/toolkit"
import { Themes, ThemeState } from "../types/theme"

const initialState: ThemeState = {
  userTheme: Themes.LIGTH,
}

const themeSlice = createSlice({
  name: "userTheme",
  initialState,
  reducers: {
    toggleThemeLigth(state) {
      state.userTheme = Themes.LIGTH
    },
    toggleThemeDark(state) {
      state.userTheme = Themes.DARK
    },
    toggleThemeGeek(state) {
      state.userTheme = Themes.GEEK
    },
  },
})

export const { toggleThemeLigth, toggleThemeDark, toggleThemeGeek } = themeSlice.actions
export default themeSlice.reducer
